import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import { toPng } from "html-to-image";
import { QRCode } from "react-qrcode-logo";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";

class TxnMixGCash extends Component {
    constructor(props) {
        super(props);
        this.state = {
            layout: "emu",
            step: "phone_number",
            imageContent: "",
            qrCodeId: Date.now().toString(),
        };
    }

    componentDidMount = async () => {
        $(document).prop("title", "E-Wallet Payment Information");
        // $("#favicon").attr("href", "/images/gcash/base_icon.png");
        this.props.i18n.changeLanguage(this.props.lngName);
        // console.log(this.props.data.detail.qrcode);
        // Func.swalAlertFunction(
        //     "Important",
        //     this.props.t("Cashier.QrCodeUsingRule2"),
        //     "info",
        //     () => this.doHtmlToImage(),
        //     30000
        // );
        // this.checkCanvas = setInterval(() => {
        //     let cvId = "qr_" + this.state.qrCodeId + "_code";
        //     let imgId = "img_" + this.state.qrCodeId;
        //     if ($("#" + cvId)) {
        //         let imgData = "";
        //         $("#" + cvId).css("display", "none");
        //         try {
        //             imgData = document.getElementById(cvId).toDataURL();
        //             let cvHeight = $("#" + cvId).css("height");
        //             let cvWidth = $("#" + cvId).css("width");
        //             if ($("#" + imgId)) {
        //                 $("#" + imgId).attr("src", imgData);
        //                 $("#" + imgId).css("height", cvHeight);
        //                 $("#" + imgId).css("width", cvWidth);
        //                 $("#" + imgId).css("display", "inline-block");
        //             }
        //         } catch (err) {}
        //     }
        // }, 200);
    };

    componentWillUnmount = async () => {
        $(document).prop("title", "GCash");
        clearInterval(this.checkCanvas);
        this.checkCanvas = null;
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    showPayerInfo = () => {
        return this.props.payerName.substr(1);
    };

    showAmount = () => {
        return parseFloat(this.props.data.amount)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    };

    downoladClickConfirm = () => {
        Func.swalConfirm(
            "Question",
            "Are you sure to download the QR code for this transaction?",
            "question",
            () => this.downoladClick(),
            () =>
                Func.swalAlert(
                    this.props.t("Conversation.Title.Warning"),
                    this.props.t("Conversation.Content.AlreadyCancelRequest"),
                    "warning"
                )
        );
    };

    openGCashAppConfirm = () => {
        // Func.swalConfirm(
        //     "Question",
        //     "Do you want to open GCash APP?",
        //     "question",
        //     () => this.openGCashApp(),
        //     () =>
        //         Func.swalAlert(
        //             this.props.t("Conversation.Title.Warning"),
        //             this.props.t("Conversation.Content.AlreadyCancelRequest"),
        //             "warning"
        //         )
        // );
        this.openGCashApp();
    };

    downoladClick = async () => {
        // let base64url = this.props.data.detail.qrcode;
        let base64url = "";
        let fileFullName = "QrCode-" + this.props.data.cashierNo + ".png";

        let node = document.getElementById(
            "qr_" + this.state.qrCodeId + "_code_main"
        );

        const canvas = node.querySelector("canvas");

        let imageContent = canvas.toDataURL("image/png");

        //await Func.sleep(1000);

        if (imageContent != "") {
            base64url = imageContent;
        } else {
            if (this.state.imageContent != "") {
                base64url = this.state.imageContent;
            } else {
                Func.swalAlert("Warning", "Download QR Code Fail.", "warning");
                return;
            }
        }

        if (this.isIphone()) {
            let blob = await (await fetch(base64url)).blob();
            let file = new File([blob], fileFullName, {
                type: "image/png",
            });

            if (navigator.canShare({ files: [file] })) {
                try {
                    await navigator.share({
                        title: "QRPH-" + this.props.data.cashierNo,
                        text: "QRPH-" + this.props.data.cashierNo,
                        files: [file],
                    });
                    Func.swalConfirm(
                        "Success",
                        'The download is successful, the QR code file name is "' +
                            fileFullName +
                            '". Do you want to open GCash APP?',
                        "success",
                        () => this.openGCashApp()
                    );
                } catch (err) {}
            } else {
                Func.swalAlert(
                    "Info",
                    this.props.t("Cashier.QrCodeShareUnsupport") + ".",
                    "info"
                );
            }
        } else if (this.isAndroid()) {
            let a = document.createElement("a");
            a.href = base64url;
            a.download = fileFullName;
            // a.setAttribute("type", "image/png");
            a.click();
            Func.swalConfirm(
                "Success",
                'The download is successful, the QR code file name is "' +
                    fileFullName +
                    '". Do you want to open GCash APP?',
                "success",
                () => this.openGCashApp()
            );
        }
    };

    openGCashApp = () => {
        if (this.props.data.detail.hasOwnProperty("extend2")) {
            setTimeout(() => {
                // window.location = this.props.data.detail.extend2;
                window.open(this.props.data.detail.extend2, "_blank", "popup");
            }, 100);
        } else if (this.props.data.detail.hasOwnProperty("extend")) {
            setTimeout(() => {
                // window.location = this.props.data.detail.extend;
                window.open(this.props.data.detail.extend, "_blank", "popup");
            }, 100);
        }
    };

    isIphone = () => {
        let nua = navigator.userAgent;

        if (nua.includes("iPhone")) {
            return true;
        }

        return false;
    };

    isAndroid = () => {
        let nua = navigator.userAgent;

        if (nua.includes("Android")) {
            return true;
        }

        return false;
    };

    displayQrLogo = () => {
        if (this.props.data.detail.hasOwnProperty("extend2")) {
            return "";
        }

        return "/images/gcash/ic_logo_qr_ph.png";
    };

    displayAmoutInfo = (desktopCss) => {
        if (this.props.data.detail.hasOwnProperty("extend2")) {
            return "";
        }

        return (
            <div className="merchant-info" style={desktopCss.merchantInfo}>
                <div className="row" style={desktopCss.merchantInfoRow}>
                    <label style={desktopCss.merchantInfoRowLabel}>
                        {this.props.t("Cashier.CashierQRTransUniNo2")}
                    </label>
                    <span
                        className="merchant-name"
                        style={desktopCss.merchantNameSp}
                    >
                        {this.props.data.cashierNo}
                    </span>
                </div>
                <div className="row" style={desktopCss.merchantInfoRow}>
                    <label style={desktopCss.merchantInfoRowLabel}>
                        Amount Due
                    </label>
                    <span className="amount">PHP {this.showAmount()}</span>
                </div>
            </div>
        );
    };

    showStep = () => {
        let screenWidth = window.innerWidth;
        let pageFontSize = screenWidth / 7.5;
        if (pageFontSize > 60) {
            pageFontSize = 60;
        }
        if (pageFontSize == 60) {
            $(".gcashCashierHeader").css("height", "4.5rem");
            $(".gcashCashierHeader").css("margin-bottom", "-2.4rem");

            $("#gcashHeaderImg").css("margin", "0.54rem auto");
            $("#gcashHeaderImg").css("width", "4rem");

            $(".gcashCashierContent").css("margin", "0 auto 1em");
            $(".gcashCashierContent").css("background", "#fff");
        }

        $("#gcashHeaderImg").css("display", "none");

        let desktopCss = {
            merchantInfo: {},
            merchantInfoRow: {},
            merchantInfoRowLabel: {},
            pageMainH2: "",
            pageMainLogin: {},
            pageFooterButton: {},
        };

        desktopCss.merchantInfo = {
            fontSize: "0.25rem",
            padding: "0.2rem 0.2rem",
        };
        desktopCss.merchantInfoRowLabel = {
            width: "1.7rem",
        };
        desktopCss.merchantNameSp = {
            flexBasis: "unset",
        };
        if (pageFontSize == 60) {
            desktopCss.merchantInfo = {
                fontSize: "0.25rem",
                padding: "0.2rem 0.2rem",
            };
            desktopCss.merchantInfoRow = {
                lineHeight: "0.72rem",
                paddingBottom: "unset",
            };
            desktopCss.merchantInfoRowLabel = {
                width: "1.7rem",
            };
            desktopCss.pageMainH2 = "desktop-h2";
            desktopCss.pageMainLogin = {
                margin: "0.4rem 0.4rem 0",
            };
            desktopCss.pageFooterButton = {
                marginTop: "0.2rem",
            };
            desktopCss.merchantNameSp = {
                flexBasis: "unset",
            };
        }

        let iPhoneStyle = {
            ipStyle: {},
            ipiStyle: {},
        };
        if (this.isIphone()) {
            iPhoneStyle.ipStyle = {
                paddingTop: ".15rem",
            };
            iPhoneStyle.ipiStyle = {
                marginBottom: "-.15rem",
            };
        }

        let grabMixStyle = {
            tagLabel: {
                color: "#000",
            },
            tagBtnMemoBgColor: {
                background: "#fff",
            },
            tagContentTextShadow: {
                textShadow: "#dc3545 0px 0px 0px",
            },
            tagContentTextShadow3: {
                textShadow: "#dc3545 0px 0px 0px",
                fontWeight: "bolder",
                fontSize: "0.2rem",
                color: "red",
                textAlign: "center",
            },
            tagContentTextShadow4: {
                textShadow: "#000 0px 0px 0px",
                fontWeight: "bolder",
                fontSize: "0.27rem",
                color: "black",
                textAlign: "center",
            },
            qrCodeExtendBtn: {
                height: "unset",
            },
            qrBtnMarginTopBottom: {
                marginTop: "0.1rem",
                marginBottom: "0.1rem",
            },
            qrBtnDisplayNone: {
                display: "none",
            },
            qrBtnDisplayShow: {},
            tagContentTextShadow2: {
                textShadow: "#dc3545 0px 0px 0px",
                justifyContent: "center",
                textAlign: "center",
            },
            ePaysIcon: {
                width: "0.5rem",
                margin: "2px",
            },
            pageImgStyle: {
                width: "100%",
            },
            qrCodeDiv: {
                textAlign: "center",
            },
            qrCodeDivImg: {
                width: "75%",
                maxWidth: "300px",
            },
            titleContentText: {
                textAlign: "center",
                fontSize: "0.3rem",
            },
            htmlChgContentBgColor: {
                backgroundColor: "#FFF",
            },
            deepLinkBtn: {
                height: "0.70rem",
                lineHeight: "0.70rem",
            },
            qrHide: {
                display: "none",
            },
            qrNormal: {},
            imgHide: {
                display: "none",
            },
        };

        let isPhone = false;
        if (this.isIphone() || this.isAndroid()) {
            isPhone = true;
        }

        let qrWidth = 60;
        if (isPhone) {
            qrWidth = 68;
        }

        setTimeout(() => {
            $("#inpPhNext").css("opacity", "1");
            $("#inpPhNext").css("background-color", "#0057e4");

            this.scrollToTop();
        }, 1000);

        let qrDisplay = grabMixStyle.qrNormal;
        // if (isPhone) {
        //     if (this.props.data.detail.hasOwnProperty("extend2")) {
        //         qrDisplay = grabMixStyle.qrHide;
        //     }
        // }

        return (
            <div
                id="htmlChgContent"
                className="main-container gcash-login-page"
                style={grabMixStyle.htmlChgContentBgColor}
            >
                {this.displayAmoutInfo(desktopCss)}
                <div className="page-container">
                    <footer
                        style={
                            isPhone
                                ? grabMixStyle.qrBtnDisplayShow
                                : grabMixStyle.qrBtnDisplayNone
                        }
                    >
                        <div
                            className="submit-button display-mobile"
                            style={desktopCss.pageFooterButton}
                        >
                            {/* <button
                                id="inpPhNext"
                                type="button"
                                className="ap-button ap-button-primary"
                                accessbilityid="next-button"
                                onClick={() => this.downoladClickConfirm()}
                            >
                                DOWNLOAD QR
                            </button>
                            <br /> */}
                            <button
                                id="inpPhOpenGCashApp"
                                type="button"
                                className="ap-button ap-button-primary"
                                accessbilityid="next-button"
                                style={grabMixStyle.deepLinkBtn}
                                onClick={() => this.openGCashAppConfirm()}
                            >
                                OPEN in E-Wallet APP
                            </button>
                        </div>
                    </footer>
                    <div
                        id="pageMain"
                        className="page-main content-center"
                        style={qrDisplay}
                    >
                        <div className="login" style={desktopCss.pageMainLogin}>
                            <div
                                accessbilityid="mobile-input"
                                className="m-input hasPrefix notEmpty"
                                autoFocus="autofocus"
                            >
                                <div style={grabMixStyle.titleContentText}>
                                    Scan this QR with the QR Scanner
                                </div>
                                <div
                                    id={
                                        "qr_" +
                                        this.state.qrCodeId +
                                        "_code_main"
                                    }
                                    style={grabMixStyle.qrCodeDiv}
                                >
                                    <QRCode
                                        id={
                                            "qr_" +
                                            this.state.qrCodeId +
                                            "_code"
                                        }
                                        value={this.props.data.detail.qrcode}
                                        ecLevel="M"
                                        size={
                                            $("#pageMain").width() *
                                            (qrWidth / 100)
                                        }
                                        logoImage={this.displayQrLogo()}
                                        // qrStyle={this.props.styles.qrCode}
                                        // style={qrDisplay}
                                    />

                                    {/* <img
                                        id={"img_" + this.state.qrCodeId}
                                        src=""
                                        style={grabMixStyle.imgHide}
                                    /> */}
                                </div>
                                {/* <div style={grabMixStyle.tagContentTextShadow2}>
                                    <span class="badge bg-warning">
                                        NO FEES!
                                    </span>
                                </div> */}
                                {/* <div style={grabMixStyle.tagContentTextShadow2}>
                                    <img
                                        src="/images/GCash2.png"
                                        style={grabMixStyle.ePaysIcon}
                                    />
                                    <img
                                        src="/images/maya3.png"
                                        style={grabMixStyle.ePaysIcon}
                                    />
                                    <img
                                        src="/images/BOPAY3.png"
                                        style={grabMixStyle.ePaysIcon}
                                    />
                                    <img
                                        src="/images/ShopeePay.png"
                                        style={grabMixStyle.ePaysIcon}
                                    />
                                </div> */}
                                {/* <div style={grabMixStyle.tagContentTextShadow3}>
                                    {this.props.t("Cashier.QrCodeUsingRule2")}
                                </div> */}
                                <div style={grabMixStyle.tagContentTextShadow4}>
                                    Screenshot QR code and pay with E-Wallet APP
                                    QR-function
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.isLoading ? <Loading /> : ""}
            </div>
        );
    };

    showFooter = () => {
        if (this.state.step == "phone_number") {
            let regWord = React.createElement(
                "p",
                {},
                "Don’t have a GCash account? ",
                React.createElement(
                    "span",
                    {
                        onClick: () => {
                            location.href = "https://lab.gcsh.app/r/";
                        },
                    },
                    "Register now"
                )
            );

            return regWord;
        } else {
            return "";
        }
    };

    isIphone = () => {
        let nua = navigator.userAgent;
        if (nua.includes("iPhone")) {
            return true;
        }
        if (nua.includes("Android")) {
            return true;
        }

        return false;
    };

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    doHtmlToImage = async () => {
        let imageContent = "";
        let node = document.getElementById(
            "qr_" + this.state.qrCodeId + "_code_main"
        );
        await toPng(node, { cacheBust: false })
            .then((dataUrl) => {
                // Func.showLog(dataUrl);
                // imageContent = dataUrl;
                imageContent = dataUrl;
                this.setState({
                    // pageStatus: "Success",
                    imageContent: dataUrl,
                });
                // var img = new Image();
                // img.src = dataUrl;
                // img.width = 340;
                // document.body.appendChild(img);
            })
            .catch((err) => {
                Func.showLog(err);
                // this.setState({ pageStatus: "Error3" });
            });
        return imageContent;
    };

    render() {
        let screenWidth = window.innerWidth;
        let pageFontSize = screenWidth / 7.5;
        if (pageFontSize > 60) {
            pageFontSize = 60;
        }
        if (pageFontSize == 60) {
            $(".gcashCashierHeader").css("height", "4.5rem");
            $(".gcashCashierHeader").css("margin-bottom", "-2.4rem");

            $("#gcashHeaderImg").css("margin", "0.54rem auto");
            $("#gcashHeaderImg").css("width", "4rem");

            $(".gcashCashierContent").css("margin", "0 auto 1em");
            $(".gcashCashierContent").css("background", "#fff");
        }

        return (
            <div className="card gcashCashierMain">
                <div className="card-header gcashCashierHeader">
                    <img
                        id="gcashHeaderImg"
                        src="/images/gcash/gcash-white-new-logo.png"
                        alt=""
                    />
                </div>
                <div className="card-body gcashCashierContent">
                    {this.showStep()}
                </div>
                <div className="card-footer gcashCashierFooter">
                    {/* {this.showFooter()} */}
                </div>
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(TxnMixGCash), TxnMixGCash);
